const stringToArray = (str: string) => str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g) || []

const countBytes = (str: string) => {
  if (str.length <= 0) {
    return 0
  }

  let len = 0
  const array = stringToArray(str)
  for (let i = 0; i < array.length; i++) {
    const char = array[i]
    len += encodeURIComponent(char).replace(/%../g, '*').length
  }
  return len
}

const countHalfwidth = (str: string) => {
  if (str.length <= 0) {
    return 0
  }
  let len = 0
  const array = stringToArray(str)
  for (let i = 0; i < array.length; i++) {
    const char = array[i]
    if (char.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) {
      len += 2
    }
    else {
      len += 1
    }
  }
  return len
}

const countFullwidth = (str: string) => {
  return countHalfwidth(str) / 2.0
}

export { countBytes, countHalfwidth, countFullwidth }
